import { DialogTitle, Divider, Dialog, DialogContent } from '@mui/material'
import { DadosCadastrais } from '../../consultorio/atendimentoMedico/components/DadosCadastrais'

const ModalDadosCadastrais = ({
  data,
  openModalDadosCadastrais,
  setOpenModalDadosCadastrais,
  setRefresh,
}) => {
  const handleFalse = () => {
    setRefresh((v) => !v)
    setOpenModalDadosCadastrais(false)
  }

  const onCancel = () => {
    handleFalse()
  }

  const onConfirm = () => {
    handleFalse()
  }

  return (
    <Dialog maxWidth="lg" open={openModalDadosCadastrais} onClose={handleFalse}>
      <DialogTitle divider>Informações do Paciente</DialogTitle>
      <Divider />
      <DialogContent>
        <DadosCadastrais
          idAtendimento={data.idAtendimento || undefined}
          pacienteSelecionado={{
            idPaciente: data.dados?.[0],
            nmPaciente: data.dados?.[1],
            cdCpf: data.dados?.[2],
            dtNascimento: data.dados?.[4] || null,
            tpSexo: data.dados?.[5],
            nrTelefone: data.dados?.[6] || '',
            dsEmail: data.dados?.[7],
            nmMae: data.dados?.[8],
            dsAlergia: data.dados?.[9],
            dsMedicamentoUsoContinuo: data.dados?.[10],
            dsAtividadeFisica: data.dados?.[11],
            dsLogradouro: data.dados?.[12] ?? '',
            nrLogradouro: data.dados?.[13] ?? '',
            dsBairro: data.dados?.[14] ?? '',
            dsComplemento: data.dados?.[15] ?? '',
            ufCidade: data.dados?.[16],
            idCidade: data.dados?.[17],
            cdCep: data.dados?.[18] ?? '',
            dsTamanhoRoupao: data.dados?.[19] ?? '',
            dsRestricaoAlimentar: data.dados?.[20] ?? '',
            dsHistoricoProcedimentos: data.dados?.[21] ?? '',
            dsOcupacao: data.dados?.[22] ?? '',
            documento: data.dados?.[23] ?? null,
            snEstrangeiro: data.dados?.[24] === 'S',
            cdDocumentoEstrangeiro: data.dados?.[25] ?? null,
          }}
          habInfoClinico={false}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </DialogContent>
    </Dialog>
  )
}

export default ModalDadosCadastrais
